import { useEffect } from 'react'
import { store } from './stores/Store'
import { observer } from 'mobx-react-lite'
import {LinearProgress} from '@mui/material'
import Header from './components/layout/Header'
import { Outlet, Route, Routes } from 'react-router-dom'
import ErrorBoundary from './misc/ErrorBoundary'
import NotFound from './components/errors/NotFound'
import ErrorView from './components/errors/ErrorView'
import MainView from './components/views/main/MainView'
import GuestView from './components/views/guest/GuestView'
import UiDemoView from './components/views/ui_demo/UiDemoView'
import React from 'react'
import ViewBanner from './components/layout/ViewBanner'
import BreadCrumb from './components/views/main/BreadCrumb'
import Logo from './misc/Logo'
import { Alert } from '.'
import Ajax from './Ajax'


export default observer(function App() {

	const { token, getURLPeram, appLoaded, init, resetApp, setToken, getCookie } = store.AppStore
	const [submittingOauthCode, setSubmittingOauthCode] = React.useState(false)

	// This is where we re-authenticate after a page refresh
	const loadAuthentication = async () => {

		try {
			
			// Attempt to sign in user via OAuth using 'code' parameter in URI
			var code = getURLPeram(window.location.href, "code")
			var state = getURLPeram(window.location.href, "state")

			if (code && state) {
				console.log("Starting frontend with OAuth code")
				setSubmittingOauthCode(true)
				var response = await Ajax.Session.LoginOAuth({code: code, state: state})
				setToken(response.data.token)
				await init()
				setSubmittingOauthCode(false)
				return
			}

			init()
			return

		} catch (e) {
			console.log(e)
			Alert({message: "Failed to load Authentication"})
		}

		console.log("Starting frontend authenticated, going to login page")

		// Set when someone is starting AORA using a link to a specific resource. 
		// If they have to authenticate first then we can get them to the resource after.
		if (!window.document.referrer.includes("aoralaw.com") && window.location.href.includes("/app/main/")) {
			localStorage.setItem("redirect_after_login", window.location.href)
		}

		resetApp()
	}

	useEffect(() => {
		
		var message = store.AppStore.getURLPeram(window.location.href, "message")
		if (message) {
			Alert({message: decodeURI(message)})
		}

		loadAuthentication()

	}, [store.AppStore])

	if (submittingOauthCode) {
		return (
			<div>
				<LinearProgress />
				
				<div style={{width: "fit-content", display: "flex", alignItems: "baseline", gap: "6px", margin: "50px auto", textAlign: "center"}}>
					<h3>Signing you into</h3>
					<Logo height={12} type="block" />
				</div>
			</div>
		)
	}

	if (!appLoaded) return <LinearProgress />

	return (
		<div className="App">
			<Routes>

				<Route path="/" element={<GuestView />} />
				<Route path="/error/:error" element={<ErrorView />} />

				<Route path="/app" element={<AuthenticatedRoutes />}>
					<Route path="main" element={<MainView />} />
					<Route path="main/:folder_uid" element={<MainView />} />
					<Route path="main/:folder_uid/:leafnode_uid" element={<MainView />} />
					<Route path="ui-demo" element={<UiDemoView />} />
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</div>
	)
})


function AuthenticatedRoutes () {        

    if (!store.AppStore.isLoggedIn) return <></>

    return (
        <ErrorBoundary>
            <Header />
            <ViewBanner title={<BreadCrumb />} />
            <Outlet />
        </ErrorBoundary>
    )
}
